import { render, staticRenderFns } from "./e_router.vue?vue&type=template&id=0f3465fd&"
import script from "./e_router.vue?vue&type=script&lang=js&"
export * from "./e_router.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports